const DEV_STORES = {
    "gifts-australia-uat.myshopify.com": {
        storefront: "3d501e8c59050e0479f7477e3b0bf5c2",
        admin: ""
    },
    "hamper-emporium-uat.myshopify.com": {
        storefront: "53d8cafcae4344372cd39b95a8a6ea65",
        admin: ""
    },

};

const PROD_STORES = {
    'maggiebeer-dev.myshopify.com' : {
        storefront: "9a4ed9aea2e03c45ddd1d8dd2adb3cb7",
        admin: ""
    },
    "maggie-beer-uat.myshopify.com": {
        storefront: "551ec08269102da3f8566600e7d647b3",
        admin: ""
    },
    'maggie-beer.myshopify.com': {
        storefront: "89b2706276a0327abe56a5e194e7c368",
        admin: ""
    },
    'gifts-australia-prod.myshopify.com': { 
        storefront: "ab5da758671fb0d3b3b5024aaa1db538",
        admin: ""
    },
    'hamper-emporium-prod.myshopify.com': { 
        storefront: "0f51ee9d5426b73a9a287b6991d9c614",
        admin: ""
    }

}

export default {
    isDevStore() {
        return Object.hasOwn(DEV_STORES, Shopify.shop);
    },
    isProdStore() {
        return Object.hasOwn(PROD_STORES, Shopify.shop);
    },
    getPublicAccessToken() {
        if (this.isDevStore()) {
            return DEV_STORES[Shopify.shop].admin;
        } else if (this.isProdStore()) {
            return PROD_STORES[Shopify.shop].admin;
        }
        return null;
    },
    getStorefrontToken() {
        if (this.isDevStore()) {
            return DEV_STORES[Shopify.shop].storefront;
        } else if (this.isProdStore()) {
            return PROD_STORES[Shopify.shop].storefront;
        }
        return null;
    },
    getBrazeToken() {
        return '813e1c8e-282a-4446-baee-d1fc906c81cb'
    }
}
